/**
 * 아바타 채팅에서 선택 가능한 LLM 모델 목록
 *
 * - provider/modelId는 백엔드 화이트리스트(chat.py의 _get_allowed_llm_models)와
 *   일치해야 함
 * - ktcloud의 modelId는 backend/app/config/ktcloud_models.py 레지스트리 키
 */

export type LlmProvider = 'openai' | 'ktcloud'

export interface LlmModelOption {
  /** 고유 키 (localStorage 저장용) */
  key: string
  /** 드롭다운 표시명 */
  label: string
  /** 버튼에 표시할 짧은 이름 */
  shortLabel: string
  /** 부가 설명 (드롭다운 하단 표시) */
  description: string
  provider: LlmProvider
  modelId: string
}

export const LLM_MODEL_OPTIONS: LlmModelOption[] = [
  {
    key: 'gpt-4o',
    label: 'GPT-4o',
    shortLabel: 'GPT-4o',
    description: 'OpenAI (기본)',
    provider: 'openai',
    modelId: 'gpt-4o',
  },
  {
    key: 'qwen3-32b',
    label: 'Qwen3 32B',
    shortLabel: 'Qwen3',
    description: 'KT Cloud',
    provider: 'ktcloud',
    modelId: 'qwen3-32b',
  },
  {
    key: 'solar-open-100b',
    label: 'Solar Open 100B',
    shortLabel: 'Solar 100B',
    description: 'KT Cloud',
    provider: 'ktcloud',
    modelId: 'solar-open-100b',
  },
  {
    key: 'solar-pro3',
    label: 'Solar Pro 3',
    shortLabel: 'Solar Pro3',
    description: 'KT Cloud (추론 특화)',
    provider: 'ktcloud',
    modelId: 'solar-pro3',
  },
  {
    key: 'gpt-oss-120b',
    label: 'GPT-OSS 120B',
    shortLabel: 'GPT-OSS',
    description: 'KT Cloud (추론 특화)',
    provider: 'ktcloud',
    modelId: 'gpt-oss-120b',
  },
]

export const DEFAULT_LLM_MODEL_KEY = 'gpt-4o'

export const getLlmModelOption = (key: string): LlmModelOption =>
  LLM_MODEL_OPTIONS.find((option) => option.key === key) ??
  LLM_MODEL_OPTIONS[0]
